import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { Combination, FilterOptions, SubFamily } from "@/features/sub-families/types";
import type { Nullable } from "@/types";

type State = {
    options: Nullable<FilterOptions>;
    subFamilies: SubFamily[];
    combinations: Combination[];
};

const initialState: State = {
    options: null,
    subFamilies: [],
    combinations: [],
};

const slice = createSlice({
    name: "filter-options",
    initialState,
    reducers: {
        filterOptionsSetOptionsAction: (state: State, action: PayloadAction<FilterOptions>) => {
            state.options = action.payload;
        },
        filterOptionsSetSubFamiliesAction: (state: State, action: PayloadAction<SubFamily[]>) => {
            state.subFamilies = action.payload;
        },
        filterOptionsSetCombinationsAction: (state: State, action: PayloadAction<Combination[]>) => {
            state.combinations = action.payload;
        },
    },
});

export const { filterOptionsSetOptionsAction, filterOptionsSetSubFamiliesAction, filterOptionsSetCombinationsAction } =
    slice.actions;

export default slice.reducer;
